<script>
import { mapState } from 'vuex'

import SidebarFooter from './footer'
import SidebarForm from './form'
import SidebarHeader from './header'
import SidebarMinimizer from './minimizer'
import SidebarNavDropdown from './navDropdown'
import SidebarNavLink from './navLink'
import SidebarNavTitle from './navTitle'
import SidebarNavItem from './navItem'
export default {
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  },
  computed: {
    ...mapState({
      empresa: state => state.auth.usuario.empresa
    })
  }
}
</script>
<template>
  <div class="sidebar">
    <SidebarHeader/>
    <SidebarForm/>
    <nav class="sidebar-nav">
      <div slot="header"></div>
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <template v-if="item.title">
            <SidebarNavTitle :name="item.name" :classes="item.class" :wrapper="!item.wrapper" :key="index"/>
          </template>
          <template v-else-if="item.divider">
            <li class="divider" :key="index"></li>
          </template>
          <template v-else>
            <template v-if="item.sub">
              <!-- First level dropdown -->
              <SidebarNavDropdown :name="item.name" :url="'/' + item.path" :icon="item.icon" :key="index" :id="item.id">
                <template v-for="(childL1, index) in item.sub">
                  <template v-if="childL1.sub">
                    <!-- Second level dropdown -->
                    <SidebarNavDropdown :name="childL1.name" :url="'/' + childL1.path" :icon="childL1.icon" :key="index" :id="childL1.id">
                      <li class="nav-item" v-for="(childL2, index) in childL1.sub" :key="index">
                        <SidebarNavLink :name="childL2.name" :url="'/' + childL2.path" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant" :id="childL2.id"/>
                      </li>
                    </SidebarNavDropdown>
                  </template>
                  <template v-else>
                    <SidebarNavItem :classes="item.class" :key="index" :id="item.id">
                      <SidebarNavLink :name="childL1.name" :url="'/' + childL1.path" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant" :id="childL1.id"/>
                    </SidebarNavItem>
                  </template>
                </template>
              </SidebarNavDropdown>
            </template>
            <template v-else>
              <SidebarNavItem :classes="item.class" :key="index" :id="item.id">
                <SidebarNavLink :name="item.name" :url="'/' + item.path" :icon="item.icon" :badge="item.badge" :variant="item.variant" :id="item.id"/>
              </SidebarNavItem>
            </template>
          </template>
        </template>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter :logo="empresa.arquivo" />
  </div>
</template>
<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// index.vue?221e1d8e